"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _mixins = require("../../styles/mixins");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBCheckbox = require("./HBCheckbox.styles");
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// Due to a problem with Checkbox visibility, this is a solution for pdf printing.

var MockPrintCheckboxButton = function MockPrintCheckboxButton(_ref) {
  var size = _ref.size,
    color = _ref.color,
    isActive = _ref.isActive,
    children = _ref.children,
    margin = _ref.margin;
  return /*#__PURE__*/_react["default"].createElement(Box, {
    size: size,
    color: color,
    $isActive: isActive,
    $margin: margin
  }, /*#__PURE__*/_react["default"].createElement(Check, {
    size: size,
    $isActive: isActive
  }, children));
};
var _default = exports["default"] = MockPrintCheckboxButton; // -------------------------------- Styles -------------------------------- //
var Box = _styledComponents["default"].div.withConfig({
  displayName: "MockPrintCheckboxButton__Box",
  componentId: "sc-g5teqa-0"
})(["", " ", " ", ";border-radius:2px;border:1px solid;border-color:", ";", ";*{width:100%;height:100%;}", ""], _mixins.flexCenterAll, (0, _mixins.showInPrintOnly)('flex'), function (props) {
  return _HBCheckbox.CHECKBOX_STYLES[props.size];
}, _colors["default"].neutral600, (0, _styledIs["default"])('$isActive')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        background: ", ";\n        border-color: ", "\n    "])), function (props) {
  return props.color || _colors["default"].neutral900;
}, function (props) {
  return props.color || _colors["default"].neutral900;
}), function (props) {
  return props.$margin && (0, _styledComponents.css)(["margin:", ";"], props.$margin);
});
var Check = _styledComponents["default"].div.withConfig({
  displayName: "MockPrintCheckboxButton__Check",
  componentId: "sc-g5teqa-1"
})(["opacity:", ";"], function (props) {
  return props.$isActive ? 1 : 0;
});
//# sourceMappingURL=MockPrintCheckboxButton.js.map